<template>
  <i-bi-emoji-smile />
</template>
